import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { Spinner } from 'components';
import { authenticationService } from 'interactive-solutions/authentication';

class EIDLinkLogin extends React.Component {

  static propTypes = {
    params: PropTypes.any
  };

  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      loggingIn: true,
      loginFailed: false
    };

    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleReject = this.handleReject.bind(this);
  }

  componentDidMount () {
    // eslint-disable-next-line react/prop-types
    let eidAuthCode = this.props.location.query.code;

    if (eidAuthCode) {
      authenticationService.logoutWithoutRedirect();
      this.login(eidAuthCode);
    } else {
      this.context.router.push('login');
    }
  }

  login (eidAuthCode) {
    authenticationService.eidLinkLogin(eidAuthCode)
      .then((response) => this.handleSuccess(response))
      .catch(() => this.handleReject());
  }

  handleSuccess (response) {
    // Only available on error
    if (response.status && response.status !== 200) {
      this.handleReject();
      return false;
    }
    this.context.router.push('login');
  }

  handleReject () {
    authenticationService.logoutWithoutRedirect();

    this.setState({
      loggingIn: false,
      loginFailed: true
    });
  }

  renderContent () {
    if (this.state.loginFailed) {
      return (
        <p className="error"><Translate content='BANKID_LOGIN_FAILED'/></p>
      );
    }
    if (this.state.loggingIn) {
      return (
        <Spinner/>
      );
    }

    return false;
  }

  render () {
    return (
      <div className="link-login">
        <div className="container link-login-container">
          {this.renderContent()}
        </div>
      </div>
    );
  }

}

export default EIDLinkLogin;



/** WEBPACK FOOTER **
 ** ./src/views/eid-link/eid-link-login.js
 **/